import "./App.css"
import Header from "./components/common/header/Header"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import About from "./components/about/About"
import CourseHome from "./components/allcourses/CourseHome"
import Team from "./components/team/Team"
import Pricing from "./components/pricing/Pricing"
import Blog from "./components/blog/Blog"
import Contact from "./components/contact/Contact"
import Footer from "./components/common/footer/Footer"
import Home from "./components/home/Home"
import { useEffect, useState } from "react"
import api from "./components/api"
function App() {
  const [websiteSetting,setwebsiteSetting]=useState({})

  const getWebsiteSettings = async () => {
  try{
  const resp = await api.get(`/api/v1/website-setting`);
  setwebsiteSetting(resp?.data)  

  }catch(error){
    console.log("error",error)
  }
}

useEffect(()=>{
  getWebsiteSettings()
},[])

  return (
    <>
      <Router>
        <Header websiteSetting={websiteSetting} />
        <Switch>
          <Route exact path='/' component={Home} />
          <Route exact path='/about' component={About} />
          <Route exact path='/courses' component={CourseHome} />
          <Route exact path='/team' component={Team} />
          <Route exact path='/pricing' component={Pricing} />
          <Route exact path='/journal' component={Blog} />
          <Route exact path='/contact' component={Contact} />
        </Switch>
        <Footer websiteSetting={websiteSetting} />
      </Router>
    </>
  )
}

export default App
